import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const Faq = lazy(() => import('../../views/pages-template/faq'))
const ApiKey = lazy(() => import('../../views/pages-template/api-key'))
const Profile = lazy(() => import('../../views/pages-template/profile'))
const Pricing = lazy(() => import('../../views/pages-template/pricing'))
const License = lazy(() => import('../../views/pages-template/license'))
const Error = lazy(() => import('../../views/pages-template/misc/Error'))
const BlogList = lazy(() => import('../../views/pages-template/blog/list'))
const BlogEdit = lazy(() => import('../../views/pages-template/blog/edit'))
const BlogDetails = lazy(() => import('../../views/pages-template/blog/details'))
const ComingSoon = lazy(() => import('../../views/pages-template/misc/ComingSoon'))
const ModalExamples = lazy(() => import('../../views/pages-template/modal-examples'))
const Maintenance = lazy(() => import('../../views/pages-template/misc/Maintenance'))
const AccountSettings = lazy(() => import('../../views/pages-template/account-settings'))
const NotAuthorized = lazy(() => import('../../views/pages/misc/NotAuthorized'))
const KnowledgeBase = lazy(() => import('../../views/pages-template/knowledge-base/KnowledgeBase'))
const KnowledgeBaseCategory = lazy(() => import('../../views/pages-template/knowledge-base/KnowledgeBaseCategory'))
const KBCategoryQuestion = lazy(() => import('../../views/pages-template/knowledge-base/KnowledgeBaseCategoryQuestion'))


const PagesRoutes = [
  {
    path: '/pages-template/profile',
    element: <Profile />
  },
  {
    path: '/pages-template/faq',
    element: <Faq />
  },
  {
    path: '/pages-template/knowledge-base',
    element: <KnowledgeBase />
  },
  {
    path: '/pages-template/knowledge-base/:category',
    element: <KnowledgeBaseCategory />
  },
  {
    path: '/pages-template/knowledge-base/:category/:question',
    element: <KBCategoryQuestion />
  },
  {
    path: '/pages-template/account-settings',
    element: <AccountSettings />
  },
  {
    path: '/pages-template/license',
    element: <License />
  },
  {
    path: '/pages-template/api-key',
    element: <ApiKey />
  },
  {
    path: '/pages-template/modal-examples',
    element: <ModalExamples />
  },
  {
    path: '/pages-template/blog/list',
    element: <BlogList />
  },
  {
    path: '/pages-template/blog/detail/:id',
    element: <BlogDetails />
  },
  {
    path: '/pages-template/blog/detail',
    element: <Navigate to='/pages/blog/detail/1' />
  },
  {
    path: '/pages-template/blog/edit/:id',
    element: <BlogEdit />
  },
  {
    path: '/pages-template/blog/edit',
    element: <Navigate to='/pages/blog/edit/1' />
  },
  {
    path: '/pages-template/pricing',
    element: <Pricing />
  },
  {
    path: '/misc/coming-soon',
    element: <ComingSoon />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  },
  {
    path: '/misc/not-authorized',
    element: <NotAuthorized />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  },
  {
    path: '/misc/maintenance',
    element: <Maintenance />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  },
  {
    path: '/misc/error',
    element: <Error />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  },
  {
    path: '/pages-template/tickets/details',
    element: <Navigate to='/pages/tickets/detail/4987' />
  }

]

export default PagesRoutes
